export default __webpack_public_path__ + "static/media/3.807ebae4.png";